/* ===== FIX DEFINITIVO: NIENTE SOMME TRA I PACK ===== */
(function(){
  'use strict';

  // Limita al prodotto interessato
  var PRODUCT_HANDLE = 'masque-au-bio-collagene';
  if (!location.pathname.includes('/products/' + PRODUCT_HANDLE)) return;

  // ✅ Variante di default (dal tuo JSON)
  var VARIANT_ID = 55866704626050;

  // Riconoscimento dei 3 pack (FR/IT)
  var PACKS = [
    { re: /(3\s*pack|3\s*packs|8\s*masques|8\s*\+\s*4|8\s*maschere)/i, qty: 12 },
    { re: /(2\s*pack|2\s*packs|6\s*masques|6\s*\+\s*2|6\s*maschere)/i, qty: 8  },
    { re: /(1\s*pack|3\s*masques|3\s*\+\s*1|3\s*maschere)/i,            qty: 4  }
  ];

  function detectQtyFromPage(){
    var bits = [];
    var active = document.querySelector('.kaching-bundle-active, .kaching-selected, .selected, .active');
    if (active) bits.push(active.innerText || active.textContent || '');
    var widget = document.querySelector('.kaching, .kaching-bundle, [data-kaching]');
    if (widget) bits.push(widget.innerText || widget.textContent || '');
    var btn = document.querySelector('button[name="add"], [data-atc-form], .t4s-product-form__submit');
    if (btn) bits.push(btn.innerText || btn.textContent || '');
    var t = bits.join(' ').toLowerCase();
    for (var i=0;i<PACKS.length;i++){ if (PACKS[i].re.test(t)) return PACKS[i].qty; }
    return 4; // fallback “1 Pack”
  }

  // 🔒 Quando torni indietro dal checkout (bfcache/back-forward) → SVUOTA il carrello
  window.addEventListener('pageshow', function(e){
    var cameBack = e.persisted || (performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0] && performance.getEntriesByType('navigation')[0].type === 'back_forward');
    var fromCheckout = (document.referrer || '').indexOf('checkout') !== -1 || (document.referrer || '').indexOf('checkouts') !== -1;
    if (cameBack || fromCheckout) {
      fetch('/cart/clear.js', { method:'POST', credentials:'same-origin' }).catch(function(){});
    }
  });

  // Aggiorna il carrello in modo ATOMICO: solo la nostra variante con qty desiderata
  async function forceCartTo(qty){
    // Leggi carrello e prepara updates che azzerano tutto
    var cart = await fetch('/cart.js', {credentials:'same-origin', cache:'no-store'}).then(r=>r.json()).catch(()=>({items:[]}));
    var updates = {};
    if (cart && cart.items) cart.items.forEach(function(it){ updates[it.variant_id] = 0; });
    updates[VARIANT_ID] = qty;

    // Unica chiamata che imposta lo stato desiderato (niente somma possibile)
    await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type':'application/json' },
      body: JSON.stringify({ updates: updates })
    });

    // Verifica e redirect
    var cart2 = await fetch('/cart.js', {credentials:'same-origin', cache:'no-store'}).then(r=>r.json());
    var ok = cart2.items.length === 1 &&
             cart2.items[0].variant_id === VARIANT_ID &&
             cart2.items[0].quantity === qty;
    if (!ok) {
      // Un secondo tentativo, nel raro caso di race
      var u2 = {};
      cart2.items.forEach(function(it){ u2[it.variant_id] = 0; });
      u2[VARIANT_ID] = qty;
      await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify({ updates: u2 })
      });
    }
    window.location.assign('/checkout');
  }

  function shouldIntercept(target){
    var btn = target.closest('button,[type="submit"],a,[role="button"]');
    if (!btn) return false;
    if (btn.name === 'add' || btn.hasAttribute('data-atc-form')) return true;
    var t = (btn.innerText || btn.textContent || '').toLowerCase();
    return /(ajouter|acheter|buy|add to cart|checkout|panier)/i.test(t);
  }

  async function handleAction(e){
    if (!document.querySelector('.kaching, .kaching-bundle, [data-kaching]')) return;
    if (!shouldIntercept(e.target)) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var qty = detectQtyFromPage();

    var oldPE = document.body.style.pointerEvents;
    document.body.style.pointerEvents = 'none';
    try { await forceCartTo(qty); }
    catch (err) {
      console.error('[PACK FORCE]', err);
      window.location.assign('/cart'); // se qualcosa va storto, vedi il carrello
    }
    finally { document.body.style.pointerEvents = oldPE; }
  }

  // Intercetta PRIMA dell’app/tema
  document.addEventListener('click', handleAction, true);
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form) return;
    var action = form.getAttribute('action') || '';
    if (/\/cart\/add/.test(action)) handleAction(e);
  }, true);
})();
